var exports = {
  "K": "xe7b6e3d6--eba1bc--icon",
  "w": "xe7b6e3d6--eba1bc--logo",
};

module.exports = exports;
